debugInfoConfig.$inject = ['$compileProvider'];

export default function debugInfoConfig($compileProvider) {
  $compileProvider.preAssignBindingsEnabled(true)
}



// WEBPACK FOOTER //
// ./project/apps/factbox-app/factbox-app.legacy-compile.js